import axios from "axios";
import ToastUtils from "../utils/ToastUtils";

const instance = axios.create();

instance.interceptors.response.use(
  (res) => res,
  (error) => {
    console.log(typeof error?.response?.data, error?.response?.status);
    if (error?.response?.status === 401 || error?.response?.status === 302) {
      localStorage.removeItem("token");
      localStorage.removeItem("otp");
      localStorage.removeItem("superAdminId");
      window.location.reload();
      throw error;
    }

    if (
      typeof error?.config?.headers?.showToast === "boolean" &&
      !error?.config?.headers?.showToast
    )
      throw error;

    if (error?.response?.status >= 400 && error?.config?.method !== "get") {
      if (typeof error?.response?.data.message === "string") {
        ToastUtils.serverError(error?.response?.data.message);
      } else if (typeof error?.response?.data === "string") {
        ToastUtils.serverError(error?.response?.data);
      } else if (typeof error?.response?.data?.response === "string") {
        ToastUtils.serverError(error?.response?.data?.response);
      } else {
        ToastUtils.serverError();
      }
    }
    throw error;
  }
);

export const REQUEST_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
};

export const REQUEST_CONTENT_TYPE = {
  JSON: "application/json",
  MULTIPART: "multipart/form-data",
};

// STAGING URL
export const BASE_URL_ADMIN = process.env.REACT_APP_BASE_URL_ADMIN;

export const BASE_URL_COMPANY = process.env.REACT_APP_BASE_URL_COMPANY;

export const doFetch = (
  url,
  method = REQUEST_METHODS.GET,
  body = {},
  otherOptions = {}
) => {
  const { contentType, signal, companyApi, showToast } = otherOptions;

  const apiUrl = `${companyApi ? BASE_URL_COMPANY : BASE_URL_ADMIN}${url}`;

  let options = {
    url: apiUrl,
    method,
    headers: {
      "Content-Type": contentType ?? REQUEST_CONTENT_TYPE.JSON,
    },
  };

  const token = localStorage.getItem("token");

  if (token) {
    options.headers.Authorization = `Bearer ${token}`;
  }

  if (showToast !== undefined) {
    options.headers.showToast = showToast;
  }

  // signal to cancel request
  if (signal) {
    options.signal = signal;
  }

  if (contentType && contentType.includes("json")) {
    options.data = JSON.stringify(body);
  } else {
    options.data = body;
  }

  return instance(options);
};
